module.exports = __webpack_public_path__ + "static/media/9EFEC2EC-1EA8-428F-B7B8-05180621A064.00c2240b.JPG";